import { renderSlot as _renderSlot, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, createElementVNode as _createElementVNode } from "vue";
const _hoisted_1 = {
  key: 0,
  class: "modal fade",
  tabindex: "-1",
  style: {
    "opacity": "1",
    "display": "block",
    "background-color": "rgba(0,0,0,0.5)"
  }
};
const _hoisted_2 = {
  style: {
    "width": "100%",
    "height": "100%",
    "display": "flex",
    "justify-content": "center",
    "align-items": "center"
  }
};
const _hoisted_3 = {
  class: "modal-content",
  style: {
    "max-width": "90%",
    "max-height": "100%",
    "width": "auto"
  }
};
const _hoisted_4 = {
  class: "modal-header",
  style: {
    "background-color": "#000",
    "color": "#fff",
    "padding": "10px"
  }
};
const _hoisted_5 = {
  key: 0,
  class: "modal-title",
  style: {
    "font-weight": "bold"
  }
};
const _hoisted_6 = {
  key: 1,
  class: "modal-title",
  style: {
    "font-weight": "bold",
    "font-size": "large"
  }
};

const _hoisted_7 = /*#__PURE__*/_createTextVNode("X");

const _hoisted_8 = {
  class: "modal-body"
};
const _hoisted_9 = {
  class: "modal-footer",
  style: {
    "padding": "8px"
  }
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_el_link = _resolveComponent("el-link");

  return $props.show ? (_openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createElementVNode("div", _hoisted_3, [_createElementVNode("div", _hoisted_4, [_ctx.isPC ? (_openBlock(), _createElementBlock("h5", _hoisted_5, [_renderSlot(_ctx.$slots, "title")])) : (_openBlock(), _createElementBlock("span", _hoisted_6, [_renderSlot(_ctx.$slots, "title")])), $props.btnCloseShow ? (_openBlock(), _createBlock(_component_el_link, {
    key: 2,
    style: {
      "background-color": "#000",
      "color": "#fff"
    },
    onClick: _cache[0] || (_cache[0] = $event => $options.closeModal()),
    underline: false
  }, {
    default: _withCtx(() => [_hoisted_7]),
    _: 1
  })) : _createCommentVNode("", true)]), _createElementVNode("div", _hoisted_8, [_renderSlot(_ctx.$slots, "body")]), _createElementVNode("div", _hoisted_9, [_renderSlot(_ctx.$slots, "footer")])])])])) : _createCommentVNode("", true);
}